// @flow @jsx h

import { h } from 'preact'

type Props = {
  className: string
}

export const Arrow = (props: Props) => {
  return (
    <svg
      class={props.className}
      width='40px' height='40px' viewBox='0 0 40 40' version='1.1'
      xmlns='http://www.w3.org/2000/svg' xmlnsXlink='http://www.w3.org/1999/xlink'>
      <g>
        <polygon points='20 24.8860294 13 17.1139706 27 17.1139706 22.6470434 21.9470326' />
      </g>
    </svg>
  )
}



// WEBPACK FOOTER //
// ./src/v1/components/Menu/Arrow/index.js